'use client';

import { FC } from 'react';
import { Hint } from '@/components';
import { useLocalStorage } from '@/hooks/useLocalStorage';
import {
  CardBody,
  CardHeader,
  CollapseToggle,
  SectionLabel,
} from '@/features/pages/profile/wlas-widget/components/WlasTabsPanel/tabs/configuration/styled';
import { WlasChevronIcon } from '../../WlasParamsCard/components/WlasSection/WlasChevronIcon';
import { SectionLabelRow } from './styled';

interface FilterSectionProps {
  storageKey: string;
  title: string;
  hint?: string;
  isFirst?: boolean;
  children: React.ReactNode;
}

export const FilterSection: FC<FilterSectionProps> = ({
  storageKey,
  title,
  hint,
  isFirst,
  children,
}) => {
  const [open, setOpen] = useLocalStorage(storageKey, true);

  return (
    <div>
      <CardHeader $first={isFirst} onClick={() => setOpen((v) => !v)}>
        <SectionLabelRow>
          <SectionLabel>{title}</SectionLabel>
          {hint && (
            <span onClick={(e) => e.stopPropagation()}>
              <Hint message={hint} />
            </span>
          )}
        </SectionLabelRow>
        <CollapseToggle
          type="button"
          aria-expanded={open}
          onClick={(e) => {
            e.stopPropagation();
            setOpen((v) => !v);
          }}
        >
          <WlasChevronIcon open={open} />
        </CollapseToggle>
      </CardHeader>
      {open && <CardBody>{children}</CardBody>}
    </div>
  );
};
